import {
  useGetPatientsWithCareTeamQuery,
  useGetPatientWithChatMessagingQuery,
} from 'src/participant/patientQueries.generated'
import { useSessionUID } from 'src/session'

export enum MessageType {
  SMS,
  IN_APP,
}

export enum MessageSubmitDisplayType {
  ONE_BUTTON,
  BUTTON_GROUP,
}
interface ChatDisplayRules {
  disableChat: boolean
  messageSubmitDisplayType: MessageSubmitDisplayType
}

const useIsInChatMessagingEnabled = (uid: string) => {
  const response = useGetPatientWithChatMessagingQuery({
    variables: {
      uid,
    },
  })
  return response.data?.patient?.chatMessagingEnabled === true
}

const useDisableChat = (uid: string) => {
  const coachID = useSessionUID()
  const participantsWithCareTeam = useGetPatientsWithCareTeamQuery({
    variables: {
      uids: [uid],
    },
  })
  const participantCareTeam = participantsWithCareTeam.data?.patients?.[0]?.careTeam
  const isPrimaryCoach =
    participantCareTeam?.find((careTeam) => careTeam.coachID === coachID && careTeam.isPrimary === true) !== undefined
  return !isPrimaryCoach
}

const useGetMessageSubmitDisplayType = (uid: string): MessageSubmitDisplayType => {
  const messagingEnabled = useIsInChatMessagingEnabled(uid)
  return !messagingEnabled ? MessageSubmitDisplayType.ONE_BUTTON : MessageSubmitDisplayType.BUTTON_GROUP
}

const useChatDisplayRules = (uid: string): ChatDisplayRules => ({
  disableChat: useDisableChat(uid),
  messageSubmitDisplayType: useGetMessageSubmitDisplayType(uid),
})

export default useChatDisplayRules
